import React, { useCallback } from 'react'
import { useMutation, useQueryClient } from 'react-query'
// import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/tasks-query'
import { taskEventMutation } from 'ui-io/queries/tasks/task-event-mutation'
import { delay } from 'ui-lib/delay'
import { TaskT } from 'ui-io/task-io/task-t'
import { useNavigate } from 'react-router-dom'
import { Button, Classes } from '@blueprintjs/core'
import { ThemedDialog } from 'ui-components'

import toasts from '../../utils/toasts'
import useVerification from '../use-verification'
import {goToInbox} from '../../pages/tasks/go-to-inbox'
import { InboxViewT } from '../../pages/tasks/inbox-views'
import { TASKS_QUERY_FILTER } from 'ui-io/queries/tasks/task-query'
import { TASKS_SEARCH_QUERY } from 'ui-io/queries/tasks/tasks-query'
import useSession from 'ui-io/use-session'
// import goToAdmin from '../../pages/task-admin-page/go-to-admin'
// import { InboxViewT } from '../../pages/inbox-page/inbox-views'

const CloseTaskDialog = ({
  task,
  isModalOpen,
  toggleModal,
  prevInboxView,
  isConfigDiff,
}: {
  task: TaskT
  isModalOpen: boolean
  toggleModal: () => void
  prevInboxView?: InboxViewT
  isConfigDiff?: boolean
}) => {
  const history = useNavigate()
  const queryClient = useQueryClient()
  const { session } = useSession()
  const username = session?.username || ''
  const mutation = useMutation(taskEventMutation, {
    onError: (error) => {
      console.error(error)
      toasts.error(`Encountered an error when closing a task`)
    },
    onSuccess: async () => {
      toasts.success(`Successfully closed task`)
      await delay(500)
      queryClient.refetchQueries([TASKS_QUERY_FILTER])
      if (!prevInboxView) {
        // goToAdmin(history)
      } else {
        goToInbox(history, { view: prevInboxView })
      }
    },
    onSettled: () => {
      toggleModal()
    },
  })

  const { validator, isValidated, handleOnReset } = useVerification({
    toValidate: task.id,
  })
  const handleOnClosing = () => {
    handleOnReset()
  }
  const handleCloseTaskButtonClick = useCallback(() => {
    mutation.mutate({
      taskId: task.id,
      eventType: 'CLOSE',
      updatedBy:username
    })
  }, [mutation, task])

  return (
    <ThemedDialog
      isOpen={mutation.isLoading || isModalOpen}
      title="Close task"
      onClose={toggleModal}
      onClosing={handleOnClosing}
      icon="delete"
    >
      <div className={Classes.DIALOG_BODY}>
        You are about to close this task. If you are sure that this is what you
        want to do, please type in the last five characters of the task ID:
        {validator}
      </div>
      <div className={Classes.DIALOG_FOOTER}>
        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
          <Button onClick={toggleModal} disabled={mutation.isLoading}>
            {`${isConfigDiff ? 'Update config' : 'Cancel'}`}
          </Button>
          <Button
            intent="primary"
            disabled={!isValidated}
            loading={mutation.isLoading}
            onClick={handleCloseTaskButtonClick}
          >
            {`${isConfigDiff ? 'Close task' : 'Confirm'}`}
          </Button>
        </div>
      </div>
    </ThemedDialog>
  )
}

export default CloseTaskDialog
